import { Core } from "@faire/design-tokens";
import { BoldFormatting } from "@faire/help-center/components/utils/BoldFormatting";
import { Email } from "@faire/web/slate/icons/foundation/Email";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var LoggedOutConfirmationView = function LoggedOutConfirmationView() {
  return /*#__PURE__*/React.createElement(Column, {
    align: "flex-start"
  }, /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Email, {
    fontSize: "24px"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular",
    align: "center"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Od7YQ2",
    defaultMessage: "We\u2019ve received your request"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "U+2QLA",
    defaultMessage: "You will receive an email from one of our customer care specialists within <boldFormatting>24 business hours</boldFormatting>.",
    values: {
      boldFormatting: BoldFormatting
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }));
};
var IconWrapper = styled.div.withConfig({
  displayName: "LoggedOutConfirmationView__IconWrapper"
})(["border-radius:50%;padding-top:20px;background-color:", ";width:", ";height:", ";text-align:center;"], Core.surface.subdued, getSpacing("8x"), getSpacing("8x"));